export default __webpack_public_path__ + "static/media/transparent.b0c7086c.svg";